module.exports = __webpack_public_path__ + "img/carousel-2-1.ba750370.jpg";